import React from "react";

const Spacer = (props) => {
  const heightPX = (props?.params?.HeightInPixels ?? '') + "px";

  return <div id={props?.rendering?.uid} style={{ height: heightPX }}></div>;
};
export default Spacer;
